<template>
  <div>
    <el-radio-group v-model="path"  size="medium" @change="tabPath">
      <el-radio-button label="/recipeStatistics/drugDosage/operator">代理商药品用量</el-radio-button>
      <el-radio-button label="/recipeStatistics/drugDosage/pharmacy">药房药品用量</el-radio-button>
      <el-radio-button label="/recipeStatistics/drugDosage/equipment">设备药品用量</el-radio-button>
    </el-radio-group>
    <div style="margin-top: 20px">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "anomaly",
  data() {
    return {
      path: "/recipeStatistics/drugDosage/operator"
    }
  },
  created() {
    this.path=this.$route.path
  },
  component: {
    //someComponent
  },
  methods: {
    //
    tabPath(){
      this.$router.push(this.path)
    }
  },
  mounted() {
    //
  }
}
</script>

<style lang="scss" scoped>
.index {

}
</style>